export default "__VITE_ASSET__CSUL2ntY__"